import { Tab } from "@headlessui/react";
import React, { useEffect, useMemo, useRef, useState } from "react";
import TabsMobile from "../__template/TabsMobileComponent";
import new1 from "../../assets/images/icon_mutation/new1.svg";
import new2 from "../../assets/images/icon_mutation/new2.svg";
import paper from "../../assets/images/icon_mutation/paper.svg";
import donation from "../../assets/images/icon_mutation/donation.svg";
import withdraw from "../../assets/images/icon_mutation/withdraw.svg";
import card from "../../assets/images/icon_mutation/card.svg";
import adminTopup from "../../assets/images/icon_mutation/admin-topup.svg";
import topup from "../../assets/images/icon_mutation/Wallet.svg";
import document from "../../assets/images/icon_mutation/document.svg";
import old1 from "../../assets/images/icon_mutation/old1.svg";
import old2 from "../../assets/images/icon_mutation/old2.svg";
import {
  getAllInvoice,
  getAllInvoicePaid,
  getAllInvoiceSummary,
  invoicePayment,
} from "../../core/service/api_invoice";
import { formatCurrency } from "../../config/global";
import { useDispatch } from "react-redux";
import { useAppDispatch, useAppSelector } from "../../core/feature/hooks";
import { setLoading } from "../../core/feature/config/configSlice";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import "react-spring-bottom-sheet/dist/style.css";
import { BottomSheet } from "react-spring-bottom-sheet";
import User from "../../core/models/user";
import { toast } from "react-toastify";
import { getBalance } from "../../core/service/api_balance";
import {
  removeBalance,
  setBalance,
} from "../../core/feature/user/balanceSlice";
import { removeUser } from "../../core/feature/user/userSlice";
import CurrencyInput from "react-currency-input-field";
import { getMutation, getMutationOlder } from "../../core/service/api_mutation";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import CustomApp from "../../core/models/customApp";
import { isDarkColor } from "../../config/DarkColorChecker";
const ComponentMutation = () => {
  const is3Month = true;
  let btnMonth: any;
  let btnYear: any;
  let currentDate: any;
  let minDate2: any;
  let maxDate2: any;
  let monthYear: any;
  const user: User = useAppSelector((state) => state.user.user);
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const [mutations, setMutations] = useState<any>([]);
  const [mutationsOlder, setMutationsOlder] = useState<any>([]);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [activeTab, setActiveTab] = useState(0);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const fromDate = moment().subtract(89, "days").format("DD-MM-YYYY");
  const today = moment().format("DD-MM-YYYY");
  const fromDateOlder = "01-01-2020";
  const toDateOlder = moment().subtract(90, "days").format("DD-MM-YYYY");
  const [monthOption, setMonthOption] = useState<any>([]);
  const [yearOption, setYearOption] = useState<any>([]);
  const year = new Date().getFullYear().toString();
  const [selectedYear, setSelectedYear] = useState(year);
  const [startDate, setStartDate] = useState<any>(
    moment().startOf("month").format("DD-MM-YYYY")
  );
  const [endDate, setEndDate] = useState<any>(
    moment().endOf("month").format("DD-MM-YYYY")
  );
  let month = "";
  month = String(Number(moment().format("MM")));
  month = month.length == 2 ? month : "0" + month;
  const currentMonth = moment().format("MM");
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  currentDate = moment().subtract(89, "days").format("YYYY-MM-DD");
  minDate2 = "2020-01-01";
  maxDate2 = moment().subtract(90, "days").format("MM");

  var a = `${t("TRANSACTION.new")}`;
  var b = `${t("TRANSACTION.older")}`;

  var january = t("OTHER.month.january");
  var february = t("OTHER.month.february");
  var march = t("OTHER.month.march");
  var april = t("OTHER.month.april");
  var may = t("OTHER.month.may");
  var june = t("OTHER.month.june");
  var july = t("OTHER.month.july");
  var august = t("OTHER.month.august");
  var september = t("OTHER.month.september");
  var october = t("OTHER.month.october");
  var november = t("OTHER.month.november");
  var december = t("OTHER.month.december");
  // let [categories] = useState({
  //   [a]: [],
  //   [b]: [],
  // });
  var yearArray: any = [];
  var monthArray = [
    { value: "01", label: january },
    { value: "02", label: february },
    { value: "03", label: march },
    { value: "04", label: april },
    { value: "05", label: may },
    { value: "06", label: june },
    { value: "07", label: july },
    { value: "08", label: august },
    { value: "09", label: september },
    { value: "10", label: october },
    { value: "11", label: november },
    { value: "12", label: december },
  ];

  var neww = `${t("MUTATION.3Month")}`;
  var older = `${t("MUTATION.30Older")}`;

  let [categories] = useState({
    [neww]: [],
    [older]: [],
  });
  function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(" ");
  }

  const setIs3Month = async () => {
    // currentDate = moment().format("MM");
    let result = [];
    // for (let i = currentDate - 1; i > currentDate - 5; i--) {
    //   result.push(monthArray[(monthArray.length + i) % monthArray.length]);
    // }
    currentDate = new Date().getMonth(); // Current month (0-based index)
    const maxMonthIndex = Math.max(0, currentDate - 3);
    setMonthOption(monthArray.slice(0, maxMonthIndex + 1));
    var tempYear = parseInt(year);
    for (var i = 0; i < 3; i++) {
      var tempYear = parseInt(year) - i;
      yearArray.push({ value: `${tempYear}`, label: `${tempYear}` });
    }
    setYearOption(yearArray);
  };

  const handleChangeMonth = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newMonth = event.target.value;
    console.log(newMonth);

    setSelectedMonth(newMonth);

    if (selectedYear) {
      calculateStartAndEndDates(selectedYear, newMonth);
    }
  };

  const handleChangeYear = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newYear = event.target.value;
    console.log(newYear);

    setSelectedYear(newYear);

    if (selectedMonth) {
      calculateStartAndEndDates(newYear, selectedMonth);
    }
  };

  useEffect(() => {
    if (selectedMonth && selectedYear) {
      calculateStartAndEndDates(selectedYear, selectedMonth);
    }
  }, [selectedMonth, selectedYear]);

  const calculateStartAndEndDates = (year: string, month: string) => {
    const startDate = moment(`${year}-${month}-01`).format("DD-MM-YYYY");
    const endDate = moment(`${year}-${month}-01`)
      .endOf("month")
      .format("DD-MM-YYYY");

    setStartDate(startDate);
    setEndDate(endDate);

    getMutationsOlders();
  };

  const getMutations = async () => {
    dispatch(setLoading(true));
    getMutation(fromDate, today, 0, size)
      .then((res: any) => {
        dispatch(setLoading(false));
        setMutations(res.data.content);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const addMoreMutations = async () => {
    setPage(page + 1);

    dispatch(setLoading(true));
    getMutation(fromDate, today, page + 1, size)
      .then((res) => {
        dispatch(setLoading(false));
        setMutations(mutations.concat(res.data.content));
        console.log(res.data);
      })
      .catch((err) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const getMutationsOlders = async () => {
    dispatch(setLoading(true));
    getMutationOlder(startDate, endDate, 0, size)
      .then((res: any) => {
        dispatch(setLoading(false));
        setMutationsOlder(res.data.content);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const addMoreMutationsOlder = async () => {
    setPage(page + 1);

    dispatch(setLoading(true));
    getMutationOlder(startDate, endDate, page + 1, size)
      .then((res) => {
        dispatch(setLoading(false));
        setMutationsOlder(mutationsOlder.concat(res.data.content));
        console.log(res.data);
      })
      .catch((err) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  function getIconFromTags(tags: string) {
    var tempTags = tags.split(",");
    var array = ["invoice"];

    if (tempTags[0] == "invoice") return paper;
    if (tempTags[0] == "donation") return donation;
    if (tempTags[0] == "topup") return topup;
    if (tempTags[0] == "admin topup") return adminTopup;
    if (tempTags[0] == "cashout") return withdraw;
    if (
      tempTags[0] == "" ||
      tempTags[0] == "transfer" ||
      tempTags[0] == "admin bank"
    )
      return document;
    if (tempTags[0] == "card") return card;

    // console.log("array", tempTags);
  }

  const currentSizeMutations = useMemo(() => {
    const a = mutations.length;
    const b = a / (page + 1);
    console.log("b", a, b);

    return b;
  }, [mutations]);

  const currentSizeMutationsOlder = useMemo(() => {
    const a = mutationsOlder.length;
    const b = a / (page + 1);
    console.log("b", a, b);

    return b;
  }, [mutationsOlder]);

  const funBg = useMemo(() => {
    var str = "white";
    return "bg-" + str;
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);

    setIs3Month();
    if (activeTab == 0) {
      setPage(0);
      getMutations();
    } else {
      setPage(0);
      getMutationsOlders();
    }
  }, [activeTab]);
  return (
    <div className="min-h-screen h-full  bg-psp-primary">
      <div className={`px-8 pt-8 pb-3  sticky top-0 z-50 ${funBg}`}>
        <TabsMobile
          name={`${t("MUTATION.title")}`}
          backUrl={"home"}
        ></TabsMobile>
      </div>
      <Tab.Group
        onChange={(index) => {
          console.log("Changed selected tab to:", index);
          setActiveTab(index);
        }}
      >
        <Tab.List className="flex space-x-1  bg-white p-1  sticky top-24 z-50">
          {Object.keys(categories).map((category, key) => (
            <Tab
              key={category}
              style={{
                background: activeTab == key ? customApp.app_accent_color : "",
                color: activeTab == key ? customApp.app_accent_color : "#fff",
              }}
              className={({ selected }) =>
                classNames(
                  "w-full py-2.5 text-sm font-medium",
                  " ",
                  selected
                    ? `font-montserrat rounded-xl text-sm font-semibold ${
                        isDarkColor(customApp.app_accent_color)
                          ? "text-white"
                          : "text-black"
                      }`
                    : "text-black font-montserrat text-sm font-semibold"
                )
              }
            >
              {category}
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels>
          <Tab.Panel className="p-4 top-to-bottom">
            {mutations.length < 1 ? (
              <div className="flex justify-center">
                <span className="font-normal text-xs text-center">
                  {t("OTHER.dataNotFound")}
                </span>
              </div>
            ) : (
              <div className="flex flex-col gap-2.5">
                {mutations.map((res: any) =>
                  res.credit == "0" ? (
                    <div className="bg-white rounded-xl shadow-md font-montserrat">
                      <div className="flex flex-row px-3 py-3 gap-2 items-center">
                        <LazyLoadImage
                          effect="blur"
                          src={`${getIconFromTags(res.tags)}`}
                          className="w-14 h-14"
                        />
                        <div className="flex w-full justify-between gap-2">
                          <div className="flex flex-col grow gap-1">
                            <div className="grid grid-cols-2 items-start">
                              <span
                                className="text-psp-gray font-light"
                                style={{ fontSize: 10 }}
                              >
                                {moment(res.dateTime).format(
                                  "DD MMM YYYY, HH:mm "
                                )}
                              </span>
                              <h1 className="m-0 font-medium text-xs text-right text-red-600">
                                -{formatCurrency(res.debit)}
                              </h1>
                            </div>

                            <div className="grid grid-cols-2 items-start">
                              <h1 className="m-0 font-semibold text-xs font-montserrat">
                                {res.transactionName}
                              </h1>
                              <span className="text-psp-gray text-xs font-light text-right">
                                {t("MUTATION.balance")} :{" "}
                                {formatCurrency(res.balance)}
                              </span>
                            </div>

                            <span className="text-psp-gray text-xs font-light">
                              {res.callerName}
                            </span>
                            {res.note != "" && (
                              <span className="text-psp-gray text-xs">
                                {res.note}
                              </span>
                            )}
                          </div>
                          <div className="flex flex-0 flex-col mt-px"></div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="bg-white rounded-xl shadow-md font-montserrat">
                      <div className="flex  flex-row px-3 py-3 gap-2 items-center">
                        <LazyLoadImage
                          effect="blur"
                          src={`${getIconFromTags(res.tags)}`}
                          className="w-14 h-14"
                        />
                        <div className="flex w-full justify-between gap-2">
                          <div className="flex flex-col grow gap-1">
                            <div className="grid grid-cols-2 items-start">
                              <span
                                className="text-psp-gray font-light"
                                style={{ fontSize: 10 }}
                              >
                                {moment(res.dateTime).format(
                                  "DD MMM YYYY, HH:mm "
                                )}
                              </span>
                              <h1 className="m-0 font-medium text-xs text-right ">
                                {formatCurrency(res.credit)}
                              </h1>
                            </div>
                            <div className="grid grid-cols-2 items-start">
                              <h1 className="m-0 font-semibold text-xs font-montserrat">
                                {res.transactionName}
                              </h1>
                              <span className="text-psp-gray text-xs  text-right font-light">
                                {t("MUTATION.balance")} :{" "}
                                {formatCurrency(res.balance)}
                              </span>
                            </div>

                            <span className="text-psp-gray text-xs font-light">
                              {res.callerName}
                              {res.note}
                            </span>
                          </div>
                          <div className="flex flex-col mt-px"></div>
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
            )}

            {currentSizeMutations < 10 ? (
              ""
            ) : (
              <div className="flex w-full mt-2">
                <button
                  onClick={addMoreMutations}
                  className="w-full transparent px-2 py-2.5 rounded-lg text-psp-hover underline text-center items-center font-bold text-xs active:text-psp-active "
                >
                  {t("OTHER.showMore")}
                </button>
              </div>
            )}
          </Tab.Panel>
          <Tab.Panel className="p-4 top-to-bottom">
            <div className="flex flex-row gap-2 w-full mb-4">
              <select
                className="grow text-black bg-white font-normal text-sm rounded-lg h-10 w-fit"
                value={selectedMonth}
                onChange={handleChangeMonth}
              >
                {monthOption.map((option: any) => (
                  <option value={option.value}>{option.label}</option>
                ))}
              </select>
              <select
                className="grow text-black bg-white font-normal text-sm font-medium rounded-lg h-10 w-fit"
                value={selectedYear}
                onChange={handleChangeYear}
              >
                {yearOption.map((option: any) => (
                  <option value={option.value}>{option.label}</option>
                ))}
              </select>
            </div>
            {mutationsOlder.length < 1 ? (
              <div className="flex justify-center">
                <span className="font-normal text-xs text-center">
                  {t("OTHER.dataNotFound")}
                </span>
              </div>
            ) : (
              <div className="flex flex-col gap-2.5">
                {mutationsOlder.map((res: any) =>
                  res.credit == "0" ? (
                    <div className="bg-white rounded-xl shadow-md font-montserrat">
                      <div className="flex  flex-row px-3 py-3 gap-2 items-center">
                        <LazyLoadImage
                          effect="blur"
                          src={`${getIconFromTags(res.tags)}`}
                          className="w-14 h-14"
                        />
                        <div className="flex w-full justify-between gap-2">
                          <div className="flex flex-col grow gap-1">
                            <div className="grid grid-cols-2 items-start">
                              <span
                                className="text-psp-gray font-light"
                                style={{ fontSize: 10 }}
                              >
                                {moment(res.dateTime).format(
                                  "DD MMM YYYY, HH:mm "
                                )}
                              </span>

                              <h1 className="m-0 font-medium text-xs text-right text-red-600">
                                -{formatCurrency(res.debit)}
                              </h1>
                            </div>
                            <div className="grid grid-cols-2 items-start">
                              <h1 className="m-0 font-semibold text-xs font-montserrat">
                                {res.transactionName}
                              </h1>
                              <span className="text-psp-gray text-xs text-right font-light">
                                {t("MUTATION.balance")} :{" "}
                                {formatCurrency(res.balance)}
                              </span>
                            </div>

                            <span className="text-psp-gray text-xs font-light">
                              {res.callerName}
                              {res.note}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="bg-white rounded-xl shadow-md font-montserrat">
                      <div className="flex  flex-row px-3 py-3 gap-2 items-center">
                        <LazyLoadImage
                          effect="blur"
                          src={`${getIconFromTags(res.tags)}`}
                          className="w-14 h-14"
                        />
                        <div className="flex w-full justify-between gap-2">
                          <div className="flex flex-col grow gap-1">
                            <div className="grid grid-cols-2 items-start">
                              <span
                                className="text-psp-gray font-light"
                                style={{ fontSize: 10 }}
                              >
                                {moment(res.dateTime).format(
                                  "DD MMM YYYY, HH:mm "
                                )}
                              </span>
                              <h1 className="m-0 font-medium text-xs text-right ">
                                {formatCurrency(res.credit)}
                              </h1>
                            </div>

                            <div className="grid grid-cols-2 items-start">
                              <h1 className="m-0 font-semibold text-xs font-montserrat">
                                {res.transactionName}
                              </h1>
                              <span className="text-psp-gray text-xs  text-right font-light">
                                {t("MUTATION.balance")} :{" "}
                                {formatCurrency(res.balance)}
                              </span>
                            </div>

                            <span className="text-psp-gray text-xs font-light">
                              {res.callerName}
                              {res.note}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
            )}

            {currentSizeMutationsOlder < 10 ? (
              ""
            ) : (
              <div className="flex w-full mt-2">
                <button
                  onClick={addMoreMutationsOlder}
                  className="w-full transparent px-2 py-2.5 rounded-lg text-psp-hover underline text-center items-center font-bold text-xs active:text-psp-active "
                >
                  {t("OTHER.showMore")}
                </button>
              </div>
            )}
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

export default ComponentMutation;
